export const MAX_EMAIL_LIMIT = 5
